var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToTopBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4465 13.2L8.99648 15.65C8.82982 15.8167 8.78815 16 8.87148 16.2C8.95482 16.4 9.11315 16.5 9.34648 16.5H14.9465C15.1798 16.5 15.3382 16.4 15.4215 16.2C15.5048 16 15.4632 15.8167 15.2965 15.65L12.8465 13.2C12.6465 13 12.4132 12.9 12.1465 12.9C11.8798 12.9 11.6465 13 11.4465 13.2ZM5.14648 21C4.59648 21 4.12565 20.8042 3.73398 20.4125C3.34232 20.0208 3.14648 19.55 3.14648 19V5C3.14648 4.45 3.34232 3.97917 3.73398 3.5875C4.12565 3.19583 4.59648 3 5.14648 3H19.1465C19.6965 3 20.1673 3.19583 20.559 3.5875C20.9507 3.97917 21.1465 4.45 21.1465 5V19C21.1465 19.55 20.9507 20.0208 20.559 20.4125C20.1673 20.8042 19.6965 21 19.1465 21H5.14648ZM19.1465 8V5H5.14648V8H19.1465ZM5.14648 10V19H19.1465V10H5.14648Z",
    fill: "#4C60E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTopBlue);
export default __webpack_public_path__ + "static/media/backToTopBlue.eab7a65eb72e7acec2891cb48ff4d32b.svg";
export { ForwardRef as ReactComponent };